import ApiFaqCategory from 'types/api/FaqCategory';
import { ApiResources } from 'types/apiResources';
import { Endpoints, ListParamsDefault } from 'types/endpoints';
import ListCollection from 'types/redux/ListCollection';

import FaqCategory from 'models/FaqCategory';

import { LIST_MARKUP } from 'consts/redux';
import { withVariables } from 'utils/string';
import { request } from 'services/Api';

export interface ListParams extends ListParamsDefault {}
export const list = async (params?: ListParams): Promise<ListCollection<FaqCategory>> => {
    const response = await request({
        method: 'GET',
        path: withVariables(Endpoints.PublicFaqCategories, params),
        requestParams: params,
    });

    const data = response?.payload?.data;
    const resource = data && data[ApiResources.FaqCategories];

    if(!data || !resource) {
        throw new Error('Not Found');
    }

    return {
        ...LIST_MARKUP,
        isLoaded: true,
        elements: resource
            .elements
            .map((element: ApiFaqCategory) => new FaqCategory(element)),
        meta: resource.meta,
    };
};
